import React, {FunctionComponent} from 'react';
import {KontaktTextblock} from './KontaktTextblock';

export const Kontakt: FunctionComponent = () => (
    <>
        <KontaktTextblock/>
    </>
);